(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoUAEVService', ReporteEvaluativoUAEVService);

    ReporteEvaluativoUAEVService.$inject = ['$resource'];

    function ReporteEvaluativoUAEVService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteUAEV:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteuaev:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteuaev:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteuaev:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteuaev:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
